export const getImageDataUrl = (imageUrl) =>
  new Promise((resolve) => {
    if (imageUrl) {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        let canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.getContext("2d").drawImage(img, 0, 0);

        resolve(canvas.toDataURL("image/png"));
        canvas = null;
      };
      img.onerror = () => resolve(null);
      img.src = imageUrl;
    } else {
      resolve(null);
    }
  });

export const getAvatarDataUrl = (profile) =>
  new Promise((resolve) => {
    const avatar = profile.avatar || profile.profile?.avatar;
    if (avatar?.custom) {
      getImageDataUrl(avatar.resume_url).then(resolve);
    } else {
      resolve(null);
    }
  });
